'use strict';
import WebFormRequest from 'components/webFormRequest';

document.addEventListener('DOMContentLoaded', () => {
    WebFormRequest.init();
});